import { Autocomplete, TextField } from '@mui/material';
import type { CatalogOption } from './useCatalog';

/**
 * Reference pickers (D-page-schema-editor-8a). Each searches the EXISTING catalog
 * by NAME and stores the stable SLUG on the block. A single picker for
 * featuredStore.storeId; multi pickers for storeGrid / carousel storeIds and
 * categoryStrip / carousel categoryIds.
 */

const bySlug = (options: CatalogOption[], slug: string): CatalogOption =>
  options.find((o) => o.slug === slug) ?? { slug, name: slug };

export const StorePicker = ({
  label,
  options,
  value,
  onChange,
  testId,
}: {
  label: string;
  options: CatalogOption[];
  value: string;
  onChange: (slug: string) => void;
  testId?: string;
}) => (
  <Autocomplete
    options={options}
    getOptionLabel={(o) => o.name}
    isOptionEqualToValue={(o, v) => o.slug === v.slug}
    value={value ? bySlug(options, value) : null}
    onChange={(_e, picked) => onChange(picked ? picked.slug : '')}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        margin="dense"
        size="small"
        inputProps={{ ...params.inputProps, 'data-testid': testId }}
      />
    )}
  />
);

export const MultiPicker = ({
  label,
  options,
  value,
  onChange,
  testId,
}: {
  label: string;
  options: CatalogOption[];
  value: string[];
  onChange: (slugs: string[]) => void;
  testId?: string;
}) => (
  <Autocomplete
    multiple
    disableCloseOnSelect
    options={options}
    getOptionLabel={(o) => o.name}
    isOptionEqualToValue={(o, v) => o.slug === v.slug}
    value={(value ?? []).map((s) => bySlug(options, s))}
    onChange={(_e, picked) => onChange(picked.map((p) => p.slug))}
    renderInput={(params) => (
      <TextField
        {...params}
        label={label}
        margin="dense"
        size="small"
        inputProps={{ ...params.inputProps, 'data-testid': testId }}
      />
    )}
  />
);
